<mbs-modal
  [isCustomModal]="true"
  [title]="'shared:tfa.forceMSPAppModal.title' | i18next"
  #modal>
  <ng-container modal-body>
    <p class="fw-semibold">{{ 'shared:tfa.forceMSPAppModal.tiredToTyping' | i18next }}</p>

    <p>
      {{ 'shared:tfa.forceMSPAppModal.enable' | i18next }} <br />
      <span class="fw-bold">{{ 'shared:tfa.forceMSPAppModal.oneClickConfirmation' | i18next }}</span>
    </p>

    <mbs-checkbox
      [label]="'shared:common.doNotShowAgain' | i18next"
      [formControl]="confirmationCheckbox"></mbs-checkbox>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="onForceMSPAppButtonClick()">
      {{ 'shared:tfa.forceMSPAppModal.confirmButton' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="closeModal()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
